export default "__VITE_ASSET__DQQl0Kxg__"